import React, {FC, memo} from 'react';

import styled from 'styled-components';
import colors from '../../../../config/colors';
import H2 from '../../../Headings/H2';
import parse from 'html-react-parser';

interface IEmployeDescription {
    employer: any;
}

const Description: FC<IEmployeDescription> = ({employer}) => {
    return (
      employer ?
        <EmployerDesc>
          <H2>{employer.company_name}</H2>
          {employer.company_description_srb ? parse(`${employer.company_description_srb}`) : ''}
        </EmployerDesc>
      : null
    )
}

const EmployerDesc = styled.div`
  background: ${colors.WHITE};
  box-shadow: 0 0 20px ${colors.SHADOW_GRAYDARK};
  border-radius: 10px;
  padding: 20px;
  margin: 30px 0;

  p {
    margin-bottom: 20px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
`;

export default memo(Description);